export default __webpack_public_path__ + "static/media/lep4.a697f9c9.png";